<template>
  <v-container fluid>
    <div class="invoice-view">
    <v-card flat>
      <ReportViewBar :start="dateTime.start" :end="dateTime.end" :title="`Time Clock`" :showDate="true" />
      <v-card-text>
        <v-layout row wrap class="no-print">

          <v-flex v-if="selectedLocationId" xs12 md3>
            <h4 class="font-weight-medium">Select Location</h4>
            <v-select
              v-model="selectedLocations"
              :items="locations"
              item-text="name"
              item-value="id"
              label="Select Location"
              placeholder="All Locations"
              :return-object="false"
              multiple
              chips
              @input="loadTimeClock"
              clearable
              solo
            >
            </v-select>

            
          </v-flex>

          <v-flex xs12 md3 px-2>
            <h4 class="font-weight-medium">Select Employees</h4>
            <v-select
              v-model="selectedEmployee"
              :items="employees"
              item-text="name"
              item-value="id"
              label="Select Employees"
              placeholder="All Employees"
              @input="loadTimeClock"
              clearable
              return-object
              solo
              chips
            >
            </v-select>
          </v-flex>

          <v-spacer></v-spacer>

          <v-flex xs12 md3 pt-3>
            <DateTimePicker
              :range="true"
              v-model="dateTime"
              :initStartDate="start"
              :initEndDate="end"
              @submit="loadTimeClock()"
            />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
      <v-container fluid v-else>
       
      <v-layout>
        <v-flex xs12>
          <v-card>
            <v-toolbar :color="$style.card.header" class="elevation-0">
              <v-toolbar-title>
                <v-layout row fill-height>
                  <span class="title">
                    {{ $t('pageHeader.totalHoursWorked') }} : {{ totalTime.dateString }}
                  </span>
                </v-layout>
              </v-toolbar-title>
            </v-toolbar>

            <v-layout row wrap v-if="selectedEmployee">
              <v-flex class="text-left text-capitalize ml-4">
                <div class="headline font-weight-bold">
                  {{ selectedEmployee.name }}
                </div>
                <div class="font-weight-medium">
                  <div>hourlyRate: {{ getHourlyRate }}</div>
                  <div>Total Hours Worked: {{ totalHoursWorked }}</div>
                  <div>
                    <span>Total Pay:</span>
                    <span class="font-weight-bold">{{ calculatePay | currency }}</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-card-text>
              <v-data-table :headers="headers" :items="timeClockList" :loading="loading">
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">
                    {{ props.item.clockInTime | moment('MM/DD/YYYY hh:mm A') }}
                  </td>
                  <td class="text-xs-left small-td">
                    {{ props.item.clockOutTime | moment('MM/DD/YYYY hh:mm A') }}
                  </td>
                  <td class="text-xs-left small-td">
                    {{
                      props.item.shiftDuration ? props.item.shiftDuration.dateString : 'N/A'
                    }}
                  </td>
                  <td class="text-xs-left small-td">{{ props.item.clockInNote }}</td>
                  <td class="text-xs-left small-td">{{ props.item.clockOutNote }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      </v-container>
    </v-card>
  </div>
  </v-container>
</template>
<script>
import reportService from '../../service.js'
import ReportViewBar from '@/components/ReportViewBar.vue';
import locationService from '../../../Location/service.js'
import employeeService from '../../../Employee/service.js'
import DateTimePicker from '@/components/DateTimePicker'

export default {
  name: 'reports-timeClock-list',
  components: {
    DateTimePicker,
    ReportViewBar,
  },
  data() {
    return {
      start: this.$moment().startOf('day'),
      end: this.$moment().endOf('day'),
      dateTime: {
        start: this.$moment().startOf('day').toISOString(),
        end: this.$moment().endOf('day').toISOString(),
      },
      headers: [
        {
          text: this.$t('labels.clockIn'),
          value: 'clockInTime',
          sortable: true,
        },
        {
          text: this.$t('labels.clockOut'),
          value: 'clockOutTime',
          sortable: false,
        },
        {
          text: this.$t('labels.workingHours'),
          value: 'shiftDuration',
          sortable: false,
        },
        {
          text: this.$t('labels.clockInNote'),
          value: 'clockInNote',
          sortable: false,
        },
        {
          text: this.$t('labels.clockOutNote'),
          value: 'clockOutNote',
          sortable: false,
        },
      ],
      // startDatePicker: {
      //   dialog: false,
      //   date: this.$moment()
      //     .startOf('year')
      //     .subtract(3, 'year')
      //     .utc()
      //     .format('YYYY-MM-DD'),
      // },
      // endDatePicker: {
      //   dialog: false,
      //   date: this.$moment().startOf('day').utc().format('YYYY-MM-DD'),
      // },
      loading: false,
      thisLocation: null,
      locations: [],
      selectedLocations: [],
      employees: [],
      selectedEmployee: null,
      selectedLocationId: null,
      timeClockList: [],
      totalTime: 0,
      count: 0,
    }
  },
  watch: {
    selectedEmployee(val) {
      console.log('val is :', val)
    },
  },
  async created() {
    console.log('inside created: ', this.$route.params)
    this.thisLocation = this.$route.params.LocationId
    this.selectedLocationId = this.$route.params.LocationId.id
    if (this.$route.params.LocationId && this.$route.params.LocationId.id) {
      this.selectedLocations = [this.$route.params.LocationId.id]
    }
    this.loadTimeClock()
    this.locations = (await locationService.getAll({ lite: true })).data
    this.employees = (await employeeService.getAll({ lite: true })).data
  },
  methods: {
    loadTimeClock() {
      this.loading = true
      return reportService.TimeClock.get(this.selectedEmployee && this.selectedEmployee.id, {
        start: this.dateTime.start,
        end: this.dateTime.end,
        locations: this.selectedLocations,
        EmployeeId: this.selectedEmployee && this.selectedEmployee.id,
      }).then((response) => {
        this.timeClockList = response.data.timeClockList
        this.totalTime = response.data.totalTime
        this.count = this.timeClockList.length
        this.loading = false
      })
    },
  },
  computed: {
    getHourlyRate() {
      return this.selectedEmployee.hourlyRate
    },
    totalHoursWorked() {
      console.log('this.totalTime', this.totalTime)
      return this.totalTime && this.totalTime.dateString
        ? this.totalTime.dateString
        : 'N/A'
    },
    calculatePay() {
      if (this.totalTime && this.getHourlyRate) {
        return (this.getHourlyRate * this.totalTime.totalInHours).toFixed(2)
      } else {
        return 'N/A'
      }
    },
    // startDateFormatted() {
    //   if (this.startDatePicker.date) {
    //     console.log(this.startDatePicker.date)
    //     return this.$moment(this.startDatePicker.date).format('MM/DD/YYYY')
    //   }
    //   return null
    // },
    // endDateFormatted: {
    //   get() {
    //     if (this.endDatePicker.date) {
    //       return this.$moment(this.endDatePicker.date).format('MM/DD/YYYY')
    //     }
    //     return null
    //   },
    //   set(val) {
    //     return (this.endDatePicker.date = null)
    //   },
    // },
  },
}
</script>
